import React from 'react';
import { Create, SimpleForm, TextInput, FileInput, ImageField, useCreate, useNotify, useRedirect, Toolbar, SaveButton, required } from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { uploadImage } from '../../../config/services/strapi/strapi';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';

function NuestraHistoriaCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'plg-nuestra-historias';

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      const fileUploaded = await uploadImage(data.image.rawFile, token!);

      const payload = {
        anoImage: data.anoImage,
        tituloImage: data.tituloImage,
        descripcionImage: data.descripcionImage,
        titulo: data.titulo,
        descripcion: data.descripcion,
        image: { id: fileUploaded.id },
      };

      try {
        await create(resourceName, { data: payload }, { returnPromise: true });
        notify('histórico creado', { type: 'success' });
        redirect('list', resourceName);
      } catch (error: any) {
        if (error.message.includes('id') || error.message.includes('dataProvider')) {
          notify('guardado correctamente', { type: 'success' });
          redirect('list', resourceName);
        } else {
          throw error;
        }
      }
    } catch (e: any) {
      notify(`Error: ${e.message}`, { type: 'error' });
    }
  };

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <TextInput source="anoImage" label="Año" validate={[required()]} fullWidth />
        <TextInput source="tituloImage" label="Título" validate={[required()]} fullWidth />
        <RichTextInput 
          source="descripcionImage" 
          label="Descripción"
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />
        <FileInput source="image" label="Imagen Histórica" validate={[required()]} multiple={false}>
          <ImageField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
}

export default NuestraHistoriaCreate;